import apiClient from "@/api/client";
import type { AsyncTaskRecord, TaskStatus, TaskWorkerLog } from "../types";

export interface TaskListParams {
  task_name?: string;
  /** Exact match on the record UUID or the Celery task id. */
  task_id?: string;
  status?: TaskStatus | "";
  triggered_by?: string;
  date_from?: string;
  date_to?: string;
  hours_ago?: number;
  page?: number;
  /** "1" → list ONLY system tasks (developer-only; ignored for everyone else). */
  system?: "1";
  /** "1" → list every user's tasks (privileged /dev view; ignored for everyone
   *  else). Without it the list holds only the current user's tasks. */
  all?: "1";
}

export interface TaskListMeta {
  count: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export interface TaskListResult {
  data: AsyncTaskRecord[];
  meta: TaskListMeta;
}

export interface TaskUser {
  id: number;
  name: string;
}

const wrapSingle = <T>(promise: Promise<{ data: { data: T } }>) =>
  promise.then((r) => r.data.data);

export const bgTasksApi = {
  list: (params?: TaskListParams): Promise<TaskListResult> =>
    apiClient
      .get("/bg-tasks/", { params })
      .then((r) => ({ data: r.data.data as AsyncTaskRecord[], meta: r.data.meta as TaskListMeta })),

  users: (): Promise<TaskUser[]> =>
    apiClient.get("/bg-tasks/users/").then((r) => r.data.data as TaskUser[]),

  retrieve: (id: string) =>
    wrapSingle<AsyncTaskRecord>(apiClient.get(`/bg-tasks/${id}/`)),

  cancel: (id: string) =>
    wrapSingle<AsyncTaskRecord>(apiClient.post(`/bg-tasks/${id}/cancel/`)),

  /** Surowy log workera Celery z czasu pracy zadania — deweloperzy (403 dla reszty). */
  workerLog: (id: string) =>
    wrapSingle<TaskWorkerLog>(apiClient.get(`/bg-tasks/${id}/worker-log/`)),
};
